import React from 'react'
import WidgetContainer from '../../containers/WidgetContainer'
import ImagesSection from '../../containers/ImagesSection'
import LinksSection from '../../containers/LinksSection'
import ImageBoxWrapper from './ImageBoxWrapper'
import ArticleImageBox from '../../boxes/StyledArticleImageBox'
import { sendEvent } from '../../utils/googleAnalytics'

export default (props) => {
  const {
    activeDynamicLayout,
    isOpening,
    widget,
    googleAnalytics,
    widget: {
      ad,
      boxes = [],
      imageSize = '4_3',
      name,
      utmContent,
      utmMedium,
      utmSource
    }
  } = props

  if (!boxes.length) {
    return null
  }

  const textBoxes = [...boxes]
  const headBoxes = textBoxes.splice(0, 2)

  const utmParams = {
    utmContent,
    utmMedium,
    utmSource
  }

  const handleAnchorClick = ({ url, position }) => (e) =>
    sendEvent(googleAnalytics, {
      category: 'Article',
      action: widget.name,
      label: url,
      pozice: position
    })

  const handleSectionClick = (_e, _location, box, position) =>
    sendEvent(googleAnalytics, {
      category: 'Article',
      action: widget.name,
      label: box.link,
      pozice: position
    })

  const renderImageBox = (box, index) => <ImageBoxWrapper
    activeDynamicLayout={activeDynamicLayout}
    box={box}
    imageBoxComponent={ArticleImageBox}
    imageSize={imageSize}
    index={index}
    key={`financeBox${index}`}
    utmParams={utmParams}
    handleAnchorClick={handleAnchorClick({ url: box.link, position: index + 1 })}
  />

  return (
    <WidgetContainer googleAnalytics={googleAnalytics} widget={widget} isOpening={isOpening}>
      {
        headBoxes.length > 0 &&
        <ImagesSection boxes={headBoxes} renderBox={renderImageBox}/>
      }
      {
        textBoxes.length > 0 &&
        <LinksSection
          ad={ad}
          boxes={textBoxes}
          indexShift={headBoxes.length}
          device={activeDynamicLayout}
          name={name}
          utmParams={utmParams}
          handleAnchorClick={handleSectionClick}
        />
      }
    </WidgetContainer>
  )
}
